import { useMutation, useQuery } from "@tanstack/react-query";
import { EditorApi } from "../api/editor-api";
import { DeleteOverlayTemplateResponseDto } from "@repo/api/overlays";

export function useOverlayTemplatesQuery(teamExternalId: string) {
  return useQuery({
    queryKey: overlayTemplateQueryKeys.getOverlayTemplates(teamExternalId),
    queryFn: () => EditorApi.getOverlayTemplates(teamExternalId),
  });
}

export function useDeleteOverlayTemplateMutation({
  teamExternalId,
  overlayTemplateExternalId,
  onSuccess,
  onError,
  onSettled,
}: {
  teamExternalId: string;
  overlayTemplateExternalId: string;
  onSuccess?: (data: DeleteOverlayTemplateResponseDto) => void;
  onError?: (error: Error) => void;
  onSettled?: (
    data: DeleteOverlayTemplateResponseDto | undefined,
    error: Error | null,
  ) => void;
}) {
  return useMutation({
    mutationKey: overlayTemplateQueryKeys.deleteOverlayTemplate(
      teamExternalId,
      overlayTemplateExternalId,
    ),
    mutationFn: () =>
      EditorApi.deleteOverlayTemplate(
        teamExternalId,
        overlayTemplateExternalId,
      ),
    onSuccess,
    onError,
    onSettled,
  });
}

export const overlayTemplateQueryKeys = {
  getOverlayTemplates: (teamExternalId: string) => [
    "overlay-template",
    "list",
    { teamExternalId },
  ],
  deleteOverlayTemplate: (
    teamExternalId: string,
    overlayTemplateExternalId: string,
  ) => [
    "overlay-template",
    "delete",
    { teamExternalId, overlayTemplateExternalId },
  ],
};
